import dsBridge from 'dsbridge/index.js'
import httpApp from '@/api/dsApp.js'

function dsCall(FunName, option = '', callBack) { // 无callBack 为同步调用 否则为异步调用
	if (!FunName) {
		return console.error('dsCall请传递方法名参数')
	}

	FunName = (httpApp[FunName] && httpApp[FunName].value) || FunName;

	if (typeof(option) !== 'string') {
		option = JSON.stringify(option);
	}
	if (option && Object.prototype.toString.call(option) === "[object Function]") { //第二个参数是否为函数,如果是函数就默认传参为''
		callBack = option;
		option = '';
	}

	if (callBack && Object.prototype.toString.call(callBack) === "[object Function]") {
		dsBridge.call(
			FunName,
			option,
			function(data) {
				try {
					var strs = JSON.parse(data);
					callBack(strs)
				} catch (e) {
					callBack(data)
				}
			}
		)
	} else {
		let dsBrDate = dsBridge.call(FunName, option);
		try {
			return JSON.parse(dsBrDate)
		} catch (e) {
			return dsBrDate
		}
	}

}

function dsRidge(FunName, option = '', type) { //FunName 方法名,option传递的参数(函数,或者是空间对象) ,type 是否为异步
	if (!FunName) {
		return console.error('dsBridge请传递方法名参数')
	}
	FunName = (httpApp[FunName] && httpApp[FunName].value) || FunName;
	if (!option && option !== '') {
		return console.error('dsRidge请传递命名空间或者处理函数')
	}
	var typeReg = type ? 'registerAsyn' : 'register'; //默认为同步 否则就是异步
	if (Object.prototype.toString.call(option) === "[object Function]") {

		dsBridge[typeReg](FunName, function(data) {
			try {
				var strs = JSON.parse(data);
				return option(strs)
			} catch (e) {
				return option(data)
			}
		})

	} else {
		let dsBrDate = dsBridge[typeReg](FunName, option);
		try {
			return JSON.parse(dsBrDate)
		} catch (e) {
			return dsBrDate
		}
	}

}

function hasNativeMethod(FunName, option = '') { //FunName 方法名,option传递的参数(函数,或者是空间对象)
	if (!FunName) {
		return console.error('dsBridge请传递方法名参数')
	}
	FunName = (httpApp[FunName] && httpApp[FunName].value) || FunName;
	if (!option && option !== '') {
		return console.error('dsRidge请传递命名空间或者处理函数')
	}
	if (Object.prototype.toString.call(option) === "[object Function]") {

		dsBridge.hasNativeMethod(FunName, function(data) {
			try {
				var strs = JSON.parse(data);
				return option(strs)
			} catch (e) {
				return option(data)
			}
		})

	} else {
		return dsBridge.hasNativeMethod(FunName)

	}

}

function dsShare(option) {
	let linkType = process.env.VUE_APP_TITLE || '';
	let myDate = new Date();
	let linkTime = myDate.getFullYear() + '-' + (myDate.getMonth() + 1) + '-' + myDate.getDate();
	dsBridge.call(
		'duchuang.onPageStarted',
		'{"type":"introduction_page","id":"111","url":""}'
	)
	let url = option.url || window.location.href;
	let linkUrls;
	if (url && url.indexOf('?') != -1) {
		// 存在问号
		if (util.getUrlParam('dc_app_hide_title')) {
			// 存在app参数
			linkUrls = option.url || window.location.href
		} else {
			// 不存在
			linkUrls = option.url +'&dc_app_hide_title=false' || window.location.href + '&dc_app_hide_title=false'
		}
	} else {
		linkUrls = option.url +'?dc_app_hide_title=false' ||  window.location.href + '?dc_app_hide_title=false'
	}
	dsBridge.register('duchuang', {
		tag: 'duchuang',
		returnShareInfo: () => {
			let shareData = {
				id: option.id || '',
				title: option.title || '新型冠状病毒感染的肺炎科普与服务平台',
				url: option.link || option.url || url,
				img: option.img || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg',
				summary: option.summary || '科学疫情防范，你该知道的都在这里！',
				linkSource: '读创', // 来源
				linkType: linkType, // 类型
				linkTitle: option.title || '',
				linkTime: linkTime,
				linkImg: option.img || "https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg",
				linkUrl: linkUrls
			}
			return JSON.stringify(shareData)
		}
	})

}



export default {
	dsCall: dsCall,
	dsRidge: dsRidge,
	dsHas: hasNativeMethod,
	dsShare: dsShare
}



// WEBPACK FOOTER //
// ./src/api/dsbridge.js